import { combineReducers } from 'redux';

import app from './app';
import extra from './extra';
import form from './form';
import language from './language';
import messages from './messages';

// `auth` is SSR-hydrated (see src/server/serverHelpers.js) and read by useAuth() +
// a handful of promo components; nothing on promo dispatches into it. Kept as a
// passthrough so combineReducers preserves the preloaded slice.
const auth = (state = {}) => state;

export default combineReducers({
    app,
    auth,
    language,
    form,
    messages,
    extra,
});
